<div class="form-modal">
    <div class="form-modal__body">
        <a
            tabindex="0"
            (click)="onClose()"
            class="close-modal"
            aria-label="Close add or edit resource form">
            <img src="./assets/img/icons-svg/close-icon.svg" />
        </a>
        <div class="img-wrapper">
            <div class="clearfix"></div>
            <div class="title-wrapper">
                <h1 *ngIf="resources.mode === 'update'">Edit Resource</h1>
                <h1 *ngIf="resources.mode === 'add'">Add Resource</h1>
            </div>
        </div>
        <page-loader *ngIf="isloaded"></page-loader>
        <form novalidate [formGroup]="resourceForm">
            <div id="resource-section" class="form-wrapper-80">
                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="resourcesettitle"
                        >Title <span class="required">*</span></label
                    >
                    <input
                        cdkFocusInitial
                        class="app-c-form-control"
                        tabindex="0"
                        required
                        type="text"
                        formControlName="title"
                        id="resourcesettitle" />
                    <div
                        class="error-message"
                        *ngIf="
                            isSubmitted &&
                            resourceForm.get('title').hasError('required')
                        ">
                        Title is required
                    </div>
                </div>

                <p class="hint">
                    Please fill out at least ONE of the following: Address,
                    Website, Phone # or Email Address
                </p>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="resourceSetAddress"
                        >Address</label
                    >
                    <input
                        class="app-c-form-control"
                        tabindex="0"
                        type="text"
                        formControlName="address"
                        id="resourceSetAddress" />
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="resourceSetWebsite"
                        >Website</label
                    >
                    <input
                        class="app-c-form-control"
                        tabindex="0"
                        type="text"
                        formControlName="website"
                        id="resourceSetWebsite"
                        [pattern]="urlPattern" />
                    <small class="field-hint"
                        >Examples: example.com, www.example.com,
                        https://example.com/path</small
                    >
                    <div
                        class="error-message"
                        *ngIf="
                            resourceForm.controls['website'].touched &&
                            !resourceForm.controls['website'].valid
                        ">
                        Invalid website. Try a value like example.com or
                        https://example.com
                    </div>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="resourceSetPhone"
                        >Phone #</label
                    >
                    <input
                        class="app-c-form-control"
                        tabindex="0"
                        type="text"
                        formControlName="contact"
                        id="resourceSetPhone" />
                    <small class="field-hint"
                        >Format: 123-456-7890 or +11234567890 (E.164)</small
                    >
                    <div
                        class="error-message"
                        *ngIf="
                            resourceForm.controls['contact'].touched &&
                            !resourceForm.controls['contact'].valid
                        ">
                        Invalid phone number! Format: 123-456-7890 or
                        +11234567890 (E.164)
                    </div>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="resourceSetEmail"
                        >Email Address</label
                    >
                    <input
                        class="app-c-form-control"
                        tabindex="0"
                        type="text"
                        formControlName="alternateContact"
                        id="resourceSetEmail" />
                    <div
                        class="error-message"
                        *ngIf="
                            resourceForm.controls['alternateContact'].touched &&
                            !resourceForm.controls['alternateContact'].valid
                        ">
                        Invalid email!
                    </div>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="description"
                        >Description</label
                    >
                    <input
                        class="app-c-form-control"
                        tabindex="0"
                        type="text"
                        formControlName="description"
                        id="description" />
                </div>

                <div class="app-c-form-group app-c-form-group--checkbox">
                    <label class="app-c-checkbox">
                        <input type="checkbox" formControlName="active" />
                        <span class="app-c-checkbox__label" translate
                            >Active</span
                        >
                    </label>
                </div>

                <div>
                    <ng-container *ngIf="isSubmitted">
                        <p
                            class="hint"
                            *ngIf="
                                resourceForm.get('title').hasError('required')
                            ">
                            Resource needs a title
                        </p>
                        <p
                            class="hint"
                            *ngIf="resourceForm.hasError('atLeastOne')">
                            At least ONE of Address, Website, Phone # or Email
                            Address is required!
                        </p>
                    </ng-container>
                    <div class="btn-wrapper">
                        <button
                            type="submit"
                            tabindex="0"
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            [ngClass]="{
                                'btn-disabled':
                                    !resourceForm.dirty || !resourceForm.valid,
                                'btn-primary':
                                    resourceForm.dirty && resourceForm.valid,
                            }"
                            (click)="doSave()">
                            Save
                        </button>
                        <button
                            type="submit"
                            tabindex="0"
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            [ngClass]="{
                                'btn-disabled':
                                    !resourceForm.dirty || !resourceForm.valid,
                                'btn-primary':
                                    resourceForm.dirty && resourceForm.valid,
                            }"
                            (click)="doSaveAndAdd()">
                            Save and Add Another
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
